<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>{{ $t('Webportal.CX.OrderId') }}</th>
          <th>{{ $t('Webportal.CX.OrderDate') }}</th>
          <th>{{ $t('Webportal.CX.ContactId') }}</th>
          <th>{{ $t('Webportal.CX.ProspectId') }}</th>
          <th>{{ $t('Webportal.CX.FirstNameMaintained') }}</th>
          <th>{{ $t('Webportal.CX.LastNameMaintained') }}</th>
          <th>{{ $t('Webportal.CX.EmailMaintained') }}</th>
          <th>{{ $t('Webportal.CX.PhoneMaintained') }}</th>
          <th>{{ $t('Webportal.CX.MarketingReleaseEmail') }}</th>
          <th>{{ $t('Webportal.CX.MarketingReleasePhone') }}</th>
          <th>{{ $t('Webportal.CX.FulfillmentStatus') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="e in data">
          <td>{{ e.OrderId }}</td>
          <td>{{ e.OrderDate }}</td>
          <td>{{ e.ContactId }}</td>
          <td>{{ e.ProspectId }}</td>
          <td>{{ e.FirstNameMaintained }}</td>
          <td>{{ e.LastNameMaintained }}</td>
          <td>{{ e.EmailMaintained }}</td>
          <td>{{ e.PhoneMaintained }}</td>
          <td>{{ e.MarketingReleaseEmail }}</td>
          <td>{{ e.MarketingReleasePhone }}</td>
          <td :style="`color: ${getFulfillmentStatusColor(e.FulfillmentStatus)}`"><b>{{ e.FulfillmentStatus }}</b></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
  
<script>

export default {
  props: {
    data: { type: Array,  default: [] },
    thresholds: { type: Array, required: true }
  },

  methods: {
    getFulfillmentStatusColor(text) {
      if(text.toLowerCase().trim().startsWith('nicht erfüllt')) return this.thresholds.find(s => s.Smiley == "frown-open")?.Color;
      else if(text.toLowerCase().trim().startsWith('erfüllt')) return this.thresholds.find(s => s.Smiley == "grin")?.Color;
      else return ""
    }
  },
}

</script>

<style scoped>
table {
  width: 100%;
}
thead {
  border-bottom: 3px solid rgba(128, 128, 128, 0.3607843137);
  position: sticky;
  top: 0;
  background: var(--background-color-primary);
  z-index: 1;
}
th {
  font-weight: bold !important;
  padding: 0.5rem 0rem;
}
tr {
  line-height: 1.6em;
}
tr:nth-child(even) {
  background-color: #ffffff10;
}
</style>